module.exports = __webpack_public_path__ + "img/dvla-vehicule.a4fc1470.png";